module.exports = __webpack_public_path__ + "static/media/background-min-landing.27427769.svg";